export const PAYROLL_PROCESS_FLOWS = {
  mid_month: {
    label: "Mid Month Salary",
    description:
      "Use this flow when the payroll is only salary advance or mid-month salary, without allowance calculation.",
    steps: [
      {
        title: "Check Attendance Close",
        notification:
          "Payroll cannot start until attendance for the selected period is closed. Review open, process, and close attendance counts first.",
        routeQuery: "attendance check in out",
      },
      {
        title: "Create Payroll Line Entry",
        notification:
          "Create a new payroll line entry only after the previous payroll is closed. Select the payroll date range for mid-month salary.",
        routeQuery: "payroll process",
      },
      {
        title: "Review Payroll Process Icons",
        notification:
          "Check eligible employee count, attendance close status, and process-close status before moving forward.",
        routeQuery: "payroll process",
      },
      {
        title: "Add Employee Payroll Entries",
        notification:
          "Add salary entries for all applicable employees. Mid-month salary does not include allowance checks.",
        routeQuery: "payroll line entry data",
      },
      {
        title: "Check Payslip Status",
        notification:
          "Review done and not-done payslip employees. Resolve employee change requests before approving payroll.",
        routeQuery: "open payslips",
      },
      {
        title: "Approve Payment",
        notification:
          "Approve payment only after all payslips are verified and no employee issue remains.",
        routeQuery: "payroll paid instruction",
      },
      {
        title: "Pay Employees",
        notification:
          "Process payment for selected employees. Mid-month paid amount should be considered in the full-month salary cycle.",
        routeQuery: "process payment paid instruction",
      },
      {
        title: "Close Payroll",
        notification:
          "Close the whole payroll after payment is complete. Closed payslips become available for app viewing.",
        routeQuery: "close payslips",
      },
      {
        title: "Review Payslips And Report",
        notification:
          "Check final payslips and payroll reports for audit and HR records.",
        routeQuery: "payroll reports",
      },
    ],
  },
  full_month: {
    label: "Full Month Salary",
    description:
      "Use this flow for final monthly payroll, including taxable and non-taxable allowances.",
    steps: [
      {
        title: "Check Attendance Close",
        notification:
          "Payroll cannot start until all attendance for the full month is closed.",
        routeQuery: "attendance check in out",
      },
      {
        title: "Create Payroll Line Entry",
        notification:
          "Create a new full-month payroll line entry only after the previous payroll is closed.",
        routeQuery: "payroll process",
      },
      {
        title: "Review Payroll Process Icons",
        notification:
          "Confirm eligible employees, attendance close status, and process readiness before entering payroll data.",
        routeQuery: "payroll process",
      },
      {
        title: "Add Salary And Allowance Entries",
        notification:
          "Add payroll entries for all employees and verify taxable and non-taxable allowances.",
        routeQuery: "payroll line entry data",
      },
      {
        title: "Check Payslip Status",
        notification:
          "Review completed and pending payslips. Handle any employee correction request before approval.",
        routeQuery: "open payslips",
      },
      {
        title: "Approve Payment",
        notification:
          "Approve payment after payslips, allowances, deductions, and payroll remarks are correct.",
        routeQuery: "payroll paid instruction",
      },
      {
        title: "Pay Employees",
        notification:
          "Process final monthly salary payment for all approved employees.",
        routeQuery: "process payment paid instruction",
      },
      {
        title: "Close Payroll",
        notification:
          "Close monthly payroll after payment is complete so closed payslips can be viewed in the app.",
        routeQuery: "close payslips",
      },
      {
        title: "Review Payslips And Report",
        notification:
          "Check all closed payslips and payroll reports for HR and finance records.",
        routeQuery: "payroll reports",
      },
    ],
  },
};

export function getPayrollFlow(flowKey) {
  return PAYROLL_PROCESS_FLOWS[flowKey] || PAYROLL_PROCESS_FLOWS.mid_month;
}
